var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminSettingsNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38978 1.00018C1.48626 1.00339 1.57782 1.04648 1.64499 1.12035L6.89145 6.71623C6.96091 6.79046 7 6.8911 7 6.99603C7 7.10095 6.96091 7.20159 6.89145 7.27582L1.64499 12.8717C1.57651 12.9513 1.48053 12.9976 1.37936 12.9999C1.27812 13.0022 1.18032 12.9604 1.10872 12.884C1.03712 12.8076 0.997874 12.7033 1.00009 12.5954C1.00231 12.4874 1.04566 12.3851 1.1203 12.3121L6.10442 6.99603L1.1203 1.67994C1.04837 1.60536 1.00789 1.50293 1.00789 1.39595C1.00789 1.28896 1.04854 1.18655 1.12046 1.11195C1.19239 1.03745 1.28953 0.997126 1.38978 1.00016L1.38978 1.00018Z",
    fill: "#8F9EA9",
    stroke: "#8F9EA9",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminSettingsNext);
export default __webpack_public_path__ + "static/media/adminSettingsNext.b5d7cf6cb314d610cfb6a0e5010a19a1.svg";
export { ForwardRef as ReactComponent };